<template>
    <div
        class="surface-primary rounded-card-sm flex h-full w-full items-center justify-center"
        data-mode="brand"
        :style="placeholderBackgroundColor ? { backgroundColor: placeholderBackgroundColor } : {}"
    >
        <img
            :src="imageToShow.url"
            :alt="imageToShow.alt ?? ''"
            class="object-contain"
            :class="imageClasses"
        >
    </div>
</template>

<script setup>
    const { placeholderImage, headerLogo, placeholderImageSize, placeholderBackgroundColor } =
        storeToRefs(useGlobalStore())

    const imageToShow = computed(() => {
        if (placeholderImage.value?.[0]?.url) {
            return placeholderImage.value[0]
        }
        if (headerLogo.value?.[0]?.url) {
            return headerLogo.value[0]
        }
        return null
    })

    const imageClasses = computed(() => {
        switch (placeholderImageSize.value) {
            case 'small':
                return 'w-[25%] h-[25%]'
            case 'large':
                return 'w-[70%] h-[70%]'
            case 'fill':
                return 'w-full h-full'
            case 'medium':
            default:
                return 'w-[50%] h-[50%]'
        }
    })
</script>
